import { render } from "./OuterItemPage.vue?vue&type=template&id=1b317dcb&scoped=true&ts=true"
import script from "./OuterItemPage.vue?vue&type=script&lang=ts"
export * from "./OuterItemPage.vue?vue&type=script&lang=ts"

import "./OuterItemPage.vue?vue&type=style&index=0&id=1b317dcb&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b317dcb"]])

export default __exports__